export const initialFormData = {
  // Step 1: Business Info
  businessName: '',
  contactName: '',
  email: '',
  phone: '',
  website: '',
  googleProfileLink: '',
  category: '',
  location: '',

  // Step 2: Review Goals
  primaryGoal: '',
  currentReviews: '',
  desiredReviews: '',
  channels: {
    sms: false,
    email: false,
    qrCode: false,
    website: false
  },
  tone: 'Professional',

  // Step 3: Integration
  hasExistingList: 'No',
  crmSource: '',
  dataConsent: false
};

// Basic validators that check required fields per step
export const validateStep1 = (data) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return Boolean(
    data.businessName && 
    data.contactName && 
    data.email &&
    emailRegex.test(data.email)
  );
};

export const validateStep2 = (data) => {
  const hasChannel = Object.values(data.channels).some(Boolean);
  return Boolean(data.primaryGoal && hasChannel);
};

export const validateStep3 = (data) => {
  if (!data.dataConsent) return false;
  if (data.hasExistingList === 'Yes' && !data.crmSource) return false;
  return true;
};